export enum EmployeePositionsEnum {
  CEO = 'CEO',
  Inspector = 'Inspector',
  PermitTechnician = 'Permit Technician',
  OfficeStaff = 'Office Staff',
  OfficeManager = 'Office Manager',
  Accounting = 'Accounting',
  SalesManager = 'Sales Manager'
}
